import { ISsecretariaList, SecretariaList } from "../secretaria/Secretaria";

export interface Orgao {
    id: string;
    nome: string | null;
    abreviatura?: string | null;
    descricao?: string | null;
    endereco?: string | null;
    numero?: string | null;
    complemento?: string | null;
    telefone?: string | null;
    bairro?: string | null;
    cidade?: string | null;
    cep?: string | null;
    logo?: string | null;
}

export const ISorgao: Orgao = {
    id: "",
    nome: "",
    abreviatura: "",
    descricao: "",
    endereco: "",
    numero: "",
    complemento: "",
    telefone: "",
    bairro: "",
    cidade: "",
    cep: "",    
    logo:null,
}

export interface OrgaoList {
  id: string;
  nome: string | null;
  abreviatura?: string | null;
  descricao?: string | null;

}

export const ISOrgaoList: OrgaoList = {
  id: '',
  nome: '',
  abreviatura: '',
  descricao: '',
  
};
